export default "__VITE_ASSET__DvOxvRjG__"